// translate router.meta.title, be used in breadcrumb sidebar tagsview
export function generateTitle(title) {
  // 这里用来处理国际化情况， title是菜单名
  const hasKey = this.$te('route.' + title) // 在平台一直是false
  const translatedTitle = this.$t('route.' + title) // $t :this method from vue-i18n, inject in @/lang/index.js
  // 目前不会走这里
  if (hasKey) {
    return translatedTitle
  }
  return title
}



// WEBPACK FOOTER //
// ./src/utils/i18n.js